import {Injectable} from '@angular/core';

import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {MembershipService} from '../_services/membership.service';

@Injectable()
export class UserMembershipSummariesResolver implements Resolve<any> {
    constructor(private membershipService: MembershipService) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        return this.membershipService.findSummariesByUser();
    }
}
